<div class="border bg-white rounded-3"
     [class.shadow]="!isFiltersCollapsed">
  <button
    type="button"
    id="search-filter-button"
    aria-label="Разширено търсене"
    aria-controls="filters-section"
    [class.bg-light]="!isFiltersCollapsed"
    [class.border-bottom]="!isFiltersCollapsed"
    [attr.aria-expanded]="!isFiltersCollapsed"
    class="p-3 w-100 btn btn-link text-decoration-none d-flex align-items-center justify-content-between flex-row rounded-top-3"
    [ngClass]="isFiltersCollapsed ? 'rounded-bottom-3' : 'rounded-bottom-0'"
    (click)="collapse.toggle()">
    <span class=" text-muted">
      Филтри: <strong>{{ activeFiltersCount }}</strong>
    </span>
    <span class=" text-primary-emphasis text-decoration-none">
      <span class="me-1">
        Разширено търсене
      </span>
      <small>
        <i aria-hidden="true"
           [class.rotated]="!isFiltersCollapsed"
           class="rotate-icon fa-solid fa-chevron-down">
        </i>
      </small>
    </span>
  </button>
  <div
    id="filters-section"
    #collapse="ngbCollapse"
    [(ngbCollapse)]="isFiltersCollapsed">
    <div class="p-3">
      <ng-content></ng-content>
      <hr class="my-3"/>
      <div class="d-flex justify-content-end">
        <button
          type="button"
          [disabled]="activeFiltersCount === 0"
          class="text-end btn btn-danger btn-sm"
          (click)="onClearFilters.emit(); isFiltersCollapsed=true">
          Премахни всички филтри
        </button>
      </div>
    </div>
  </div>
</div>
